<!--<ion-app>-->
<!--  <ion-router-outlet></ion-router-outlet>-->
<!--</ion-app>-->
<div class="safe-area-container">
  <router-outlet></router-outlet>
</div>
